var escape = function (query) { return query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };

function getReplaceCaption (caption, query, template) {
  if ( caption === void 0 ) caption = '';
  if ( query === void 0 ) query = '';
  if ( template === void 0 ) template = '<b>{query}</b>';

  if (query) {
    var re = new RegExp(escape(query), 'ig');
    return caption.replace(re, template.replace('{query}', query));
  }

  return caption;
}

export default getReplaceCaption;
